import {
  Button,
  Grid,
  MenuItem,
  Stack,
    Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import React from "react";
import toast from "react-hot-toast";
import { updateStakeholderApi } from "../../../components/api/StakeholderApiService";
import { recordStatus } from "../../../utils/menu-items";

const EditCustomer = (props) => {
  const { editCustomer, setEditCustomer } = props;
  return (
    <>
      <Stack direcion="column">
        <Typography variant="body1" mb={2}>
          Edit Customer
        </Typography>
        <Grid container item xs={12} spacing="8px">
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Customer Code</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={editCustomer?.data?.code}
              onChange={(e) =>
                setEditCustomer({
                  ...editCustomer,
                  data: {
                    ...editCustomer.data,
                    code: e.target.value,
                  },
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Customer Name</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={editCustomer?.data?.name}
              onChange={(e) =>
                setEditCustomer({
                  ...editCustomer,
                  data: {
                    ...editCustomer.data,
                    name: e.target.value,
                  },
                })
              }
            />
          </Grid>
<Grid item xs={12}>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Contact Persons
  </Typography>
  <Table size="small" sx={{ border: "1px solid #ccc" }}>
    <TableHead>
      <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
        <TableCell>Default</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Email</TableCell>
        <TableCell>Phone 1</TableCell>
        <TableCell>Phone 2</TableCell>
        <TableCell>Position</TableCell>
        <TableCell align="center">Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {(editCustomer?.data?.contactPersons || []).map((contact, idx) => (
        <TableRow key={idx}>
          <TableCell align="center">
            <Tooltip title={contact.isDefault ? "Default contact" : "Set as default"}>
              <span>
                <Button
                  size="small"
                  onClick={() => {
                    const updated = editCustomer.data.contactPersons.map((c, i) => ({ ...c, isDefault: i === idx }));
                    setEditCustomer({ ...editCustomer, data: { ...editCustomer.data, contactPersons: updated } });
                  }}
                  sx={{ minWidth: 0, p: 0.5, color: contact.isDefault ? "warning.main" : "action.disabled" }}
                >
                  {contact.isDefault ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                </Button>
              </span>
            </Tooltip>
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.name}
              onChange={(e) => {
                const updated = [...editCustomer.data.contactPersons];
                updated[idx].name = e.target.value;
                setEditCustomer({
                  ...editCustomer,
                  data: { ...editCustomer.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.email}
              onChange={(e) => {
                const updated = [...editCustomer.data.contactPersons];
                updated[idx].email = e.target.value;
                setEditCustomer({
                  ...editCustomer,
                  data: { ...editCustomer.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.phoneNumberOne}
              onChange={(e) => {
                const updated = [...editCustomer.data.contactPersons];
                updated[idx].phoneNumberOne = e.target.value;
                setEditCustomer({
                  ...editCustomer,
                  data: { ...editCustomer.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.phoneNumberTwo}
              onChange={(e) => {
                const updated = [...editCustomer.data.contactPersons];
                updated[idx].phoneNumberTwo = e.target.value;
                setEditCustomer({
                  ...editCustomer,
                  data: { ...editCustomer.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.position}
              onChange={(e) => {
                const updated = [...editCustomer.data.contactPersons];
                updated[idx].position = e.target.value;
                setEditCustomer({
                  ...editCustomer,
                  data: { ...editCustomer.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell align="center">
            <Button
              color="error"
              size="small"
              onClick={() => {
                const updated = [...editCustomer.data.contactPersons];
                updated.splice(idx, 1);
                setEditCustomer({
                  ...editCustomer,
                  data: { ...editCustomer.data, contactPersons: updated },
                });
              }}
            >
              Delete
            </Button>
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell colSpan={7} align="center">
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const updated = [...(editCustomer.data.contactPersons || [])];
              updated.push({
                name: "",
                email: "",
                phoneNumberOne: "",
                phoneNumberTwo: "",
                position: "",
                isDefault: updated.length === 0,
              });
              setEditCustomer({
                ...editCustomer,
                data: { ...editCustomer.data, contactPersons: updated },
              });
            }}
          >
            + Add Contact Person
          </Button>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Status</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              id="outlined-select-status"
              select
              value={editCustomer?.data?.status}
              onChange={(e) =>
                setEditCustomer({
                  ...editCustomer,
                  data: {
                    ...editCustomer.data,
                    status: e.target.value,
                  },
                })
              }
            >
              {recordStatus.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Stack direction="row" spacing={1} mt={1}>
          <Button
            variant="outlined"
            onClick={() =>
              setEditCustomer({ visible: false, data: null, index: null })
            }
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              updateStakeholderApi(editCustomer.data.id, editCustomer.data)
                .then((response) => {
                  toast.success("Customer edited successfully.");
                  window.location.reload();

                  setEditCustomer({ visible: false, data: null, index: null });
                })
                .catch((error) => {
                  toast.error("Something went wrong.");
                  console.log(error.response.data);
                });
            }}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              editCustomer.data.status = "PASSIVE";
              updateStakeholderApi(editCustomer.data.id, editCustomer.data)
                .then((response) => {
                  toast.success("Customer deleted successfully.");
                  window.location.reload();

                  setEditCustomer({ visible: false, data: null, index: null });
                })
                .catch((error) => {
                  toast.error("Something went wrong.");
                  console.log(error.response.data);
                });
            }}
          >
            Delete
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default EditCustomer;
